import type { ErrorResponse } from '@shared/types/http'

import { endpoint } from '@shared/services/endpoint'
import useSWR from 'swr'

import type { Response } from '../types/common'
import type { Post, SinglePost } from '../types/post'

import { getRequest } from '../../../shared/services/fetcher'
import { createURLParams } from '../utils'

export type GetPostRequest = {
  limit?: number
  order?: 'asc' | 'desc'
  orderby?: 'date' | 'title'
  page?: number
}

export type GetPostResponse = Response<Post[]>
export type GetPostBySlugResponse = Response<SinglePost>

export function usePost(request: GetPostRequest) {
  const params = createURLParams(request)
  return useSWR<GetPostResponse, ErrorResponse>(
    `${endpoint.frontend.POSTS}?${params.toString()}`,
    getRequest,
  )
}

export function usePostBySlug(slug: string) {
  return useSWR<SinglePost, ErrorResponse>(
    `${endpoint.frontend.POSTS}/${slug}`,
    getRequest,
  )
}
